import { render, staticRenderFns } from "./myModal.vue?vue&type=template&id=85a4f8c4&scoped=true&"
import script from "./myModal.vue?vue&type=script&lang=js&"
export * from "./myModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a4f8c4",
  null
  
)

export default component.exports